function toNumberOrNull(value) {
  if (value === '' || value == null) {
    return null;
  }
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export const PAYMENT_PLAN_INPUT_MODE = {
  AMOUNT: 'AMOUNT',
  PERCENTAGE: 'PERCENTAGE',
};

/**
 * 付款計畫表單 → `payment_plan`（camel；外層再 keysToSnake）。
 * 金額模式只送 `amount`，百分比模式只送 `percentage`；`dueDate` 選填，空字串送 null。
 * `phaseId` 指向目前有效計畫要承接的期別，新期別送 null；承接只用在核准後的異動單，草稿 POST／PATCH 不需要。
 * 未提供或無期別時回 undefined，呼叫端應省略整個欄位（後端拒收 null／{}／空 phases）。
 */
export function serializePaymentPlan(plan) {
  const phases = plan?.phases ?? [];
  if (!plan || phases.length === 0) {
    return undefined;
  }
  const inputMode = plan.inputMode === PAYMENT_PLAN_INPUT_MODE.PERCENTAGE
    ? PAYMENT_PLAN_INPUT_MODE.PERCENTAGE
    : PAYMENT_PLAN_INPUT_MODE.AMOUNT;
  const body = {
    inputMode,
    phases: phases.map((phase) => {
      const row = inputMode === PAYMENT_PLAN_INPUT_MODE.PERCENTAGE
        ? { percentage: toNumberOrNull(phase?.percentage) }
        : { amount: toNumberOrNull(phase?.amount) };
      row.dueDate = phase?.dueDate || null;
      row.phaseId = phase?.phaseId || null;
      return row;
    }),
  };
  const changeReason = String(plan.changeReason ?? '').trim();
  if (changeReason) {
    body.changeReason = changeReason;
  }
  return body;
}
